import { FieldType } from "@common/dto/field/type";

// Visual minimum for field boxes on the canvas (in px).
// GWT effectively renders fields around ~23px high; we standardize on 26px
// and use this for both min width and min height in the React editor.
export const DATASHEET_MIN_FIELD_SIZE = 26;

// Default initial dimensions for data fields (can be larger than the min).
const textFieldDimensions = {
  width: 151,
  height: DATASHEET_MIN_FIELD_SIZE,
};
const tableFieldDimensions = {
  width: 151,
  height: DATASHEET_MIN_FIELD_SIZE,
};

export const textElementDimensions = {
  width: 100,
  height: 50,
};

export const DATASHEET_DEFAULT_FIELDS_DIMENSIONS: Record<FieldType, { width: number; height: number }> = {
  [FieldType.system]: textFieldDimensions,
  [FieldType.text]: textFieldDimensions,
  [FieldType.date]: textFieldDimensions,
  [FieldType.number]: textFieldDimensions,
  [FieldType.checkbox]: textFieldDimensions,
  [FieldType.dropdown]: textFieldDimensions,
  [FieldType.image]: textFieldDimensions,
  [FieldType.lookupTable]: tableFieldDimensions,
  [FieldType.table]: tableFieldDimensions,
  [FieldType.computed]: textFieldDimensions,
  [FieldType.summary]: textFieldDimensions,
  [FieldType.tableSummary]: tableFieldDimensions,
  [FieldType.hyperlink]: textFieldDimensions,
  [FieldType.integer]: textFieldDimensions,
};
